import { useQuery } from '@tanstack/react-query';
import { schedulingApi, type Appointment } from '@/api';

const APPOINTMENT_KEY = (id: string) => ['appointments', 'appointment', id] as const;

async function fetchAppointment(appointmentId: string): Promise<Appointment> {
  return schedulingApi.getAppointment(appointmentId);
}

export function useAppointment(appointmentId: string) {
  return useQuery({
    queryKey: APPOINTMENT_KEY(appointmentId),
    queryFn: () => fetchAppointment(appointmentId),
    enabled: !!appointmentId,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}

export function useAppointmentReminders(appointmentId: string) {
  return useQuery({
    queryKey: [...APPOINTMENT_KEY(appointmentId), 'reminders'] as const,
    queryFn: () => schedulingApi.getAppointmentReminders(appointmentId),
    enabled: !!appointmentId,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    retry: 2,
  });
}
